import { create, all } from 'mathjs';
const math = create(all);

export function evaluateIt(formula: string) {
	return math.evaluate(formula);
}
